// Builds the radar from every stored source, in the browser. The Worker never parses Peter's data.
import type { StoredSource } from "../lib/api";
import { buildNetwork, type BuildResult, type IngestSource } from "../../shared/ingest";
import { slimNetwork } from "../../shared/slim";

export function buildRadar(sources: StoredSource[], today: string): BuildResult & { slim: unknown } {
  const result = buildNetwork(sources as unknown as IngestSource[], today);
  return { ...result, slim: slimNetwork(result.network) };
}
